import { CircularProgress } from '@mui/joy';
import React from 'react';
import {
  Navigate,
  Location as ReactRouterLocation,
  useLocation,
} from 'react-router-dom';

import { useCurrentUser } from '~/services/api/users/endpoints';
import { useAuthSlice } from '~/slices/auth';

export const getNavigateToPath = (location: ReactRouterLocation | URL) => {
  const ref =
    new URLSearchParams(location.search).get('ref')?.toLowerCase() ===
    'customer';

  const params = new URLSearchParams(location.search);
  const prevUrl = params.get('prevUrl') ?? '';
  const isCustomerPreviousURL = prevUrl.split('/').includes('customer');
  const isCustomer = ref || location.pathname.split('/').includes('customer') || isCustomerPreviousURL;
  return isCustomer ? '/customer/login' : '/login';
};

function NavigateToLogin() {
  const location = useLocation();
  const redirectTo = getNavigateToPath(location);

  return <Navigate to={redirectTo} />;
}

export const requireAuth = () => {
  //
};
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useCurrentUser();

  const authSlice = useAuthSlice().auth;
  const isInitialized = authSlice.isInitialized;

  if (!isInitialized || user.isLoading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <CircularProgress />
      </div>
    );
  }

  const isAuthenticated = !!authSlice.user.type;
  if (user.isError || !isAuthenticated) {
    return <NavigateToLogin />;
  }

  return <>{children}</>;
}

const USER_ROLE_VALUES = {
  1: 'WHISTLE_BLOWER',
  2: 'TENANT_USER',
  3: 'TENANT_ADMIN',
  5: 'EXTERNAL_USER',
  6: 'PARTNER_USER',
  7: 'PARTNER_ADMIN',
} as const;
type UserRole = (typeof USER_ROLE_VALUES)[keyof typeof USER_ROLE_VALUES];
const getUserTypeName = (id: number) => {
  const userType = USER_ROLE_VALUES[id as keyof typeof USER_ROLE_VALUES];
  if (userType) {
    return userType;
  }
  return null;
};

export function RequireRole({
  children,
  roles,
}: {
  roles: Array<UserRole>;
  children: React.ReactNode;
}) {
  const userType = useAuthSlice().auth.user.type;
  const isAuthorized = roles.some((role) => role === getUserTypeName(userType));

  if (!isAuthorized) {
    return <Navigate to='/forbidden' />;
  }

  return <>{children}</>;
}
